<template>
  <div v-if="isSuccess">

    <b-container id="grouped-report" fluid>
      <b-row>
        <b-col>
          <h2>Relatório Agrupado de {{ this.$gui.printReport }}</h2>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="my-3">
          <h3>{{ this.reportName }}</h3>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group v-if="false" class="w-auto d-inline-block mb-3">
            <p class="mb-2 font-weight-bold">{{ this.$gui.tickets }}:</p>
            <b-form-checkbox-group v-model="filters.type">
              <b-form-checkbox-group @input="updateForm('type', $event)" :checked="filters.type" :options="typeOptions"></b-form-checkbox-group>
            </b-form-checkbox-group>
          </b-form-group>

          <b-form-group v-if="false" class="w-auto d-inline-block mb-3">
            <p class="mb-2 font-weight-bold">Status:</p>
            <b-form-checkbox-group @input="updateForm('status', $event)" :checked="filters.status" :options="statusOptions"></b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <p class="m-0 font-weight-bold">Filtros:</p>
          <b-button class="mt-2 mr-1" v-b-modal.filter-operation>Operação</b-button>
          <b-button v-if="false" class="mt-2 mr-1" v-b-modal.filter-origin>Origem</b-button>
          <b-button v-if="false" class="mt-2 mr-1" v-b-modal.filter-number>Número</b-button>
          <b-button v-if="$gui.isEvento || false" class="mt-2 mr-1" v-b-modal.filter-code>Código</b-button>
          <b-button v-if="false" class="mt-2 mr-1" v-b-modal.filter-range>Intervalo</b-button>
          <b-button v-if="false" class="mt-2 mr-1" v-b-modal.filter-batch>{{ this.$gui.batch }}</b-button>
          <b-button v-if="false" class="mt-2 mr-1" v-b-modal.filter-dealer>{{ this.$gui.dealer }}</b-button>
          <b-button class="mt-2 mr-1" v-b-modal.filter-payment-method>Forma Pag.</b-button>
          <b-button class="mt-2 mr-1" v-b-modal.filter-date>Data</b-button>
          <b-button class="mt-2 mr-1 ml-2" variant="info" @click="showAll">Limpar filtros</b-button>
          <b-button class="mt-2 mr-1" variant="info" @click="filter">Filtrar</b-button>
          <b-button class="mt-2 mr-1 ml-2" variant="warning" @click="downloadReport">Baixar relatório</b-button>
        </b-col>

        <b-col cols="12" v-if="hasFilters" class="mt-4">
          <b-card-group>
            <b-card no-body>
              <b-list-group flush>
                <b-list-group-item v-for="(item, index) in appliedFilters" :key="index">
                  <strong>{{ item.filter }}:</strong> {{ item.values }}
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>
        </b-col>

        <b-col class="mt-4" v-if="!data.length">
          <b-alert variant="info" show>
            {{ this.$gui.emptyTicket }}
          </b-alert>
        </b-col>

        <b-col class="mt-4" v-if="data.length">

          <h4 class="mb-3">Total geral</h4>
          <p class="text-right font-italic">Relatório gerado em {{ generated_at | date }}.</p>
          <b-table
            class="mb-5"
            :hover="false"
            borderless
            responsive="md"
            :items="reportByPaymentMethodTotal"
            :fields="$gui.isEvento ? paymentMethodTotalFieldsEvento : paymentMethodTotalFieldsFicha"
            :filter-included-fields='filterOn'>
          </b-table>

          <h4 class="mb-3">Agrupado por Operação</h4>
          <b-table
            class="mb-5"
            :hover="true"
            outlined
            borderless
            responsive="md"
            :items="reportByEvent"
            :fields="operationsFields">

            <template v-slot:cell(payment_methods)="data">
              <b-table
                :hover="true"
                outlined
                :items="data.item.payment_methods"
                :fields="$gui.isEvento ? paymentMethod2FieldsEvento : paymentMethod2FieldsFicha">
              </b-table>
            </template>
          </b-table>

          <div v-if="false">
          <h4 class="mb-3">Agrupado por {{ this.$gui.batch }}</h4>
          <b-table
            class="mb-5"
            :hover="true"
            outlined
            borderless
            responsive="md"
            :items="reportByBatch"
            :fields="$gui.isEvento ? batchFieldsEvento : batchFieldsFicha">
          </b-table>

          <h4 class="mb-3">Agrupado por {{ this.$gui.dealer }}</h4>
          <b-table
            class="mb-5"
            :hover="false"
            borderless
            responsive="md"
            :items="reportByDealer"
            :fields="$gui.isEvento ? dealerFieldsEvento : dealerFieldsFicha"
            :filter-included-fields='filterOn'>

            <template v-slot:cell(batches)="data">
              <b-table
                :hover="true"
                outlined
                :items="data.item.batches"
                :fields="$gui.isEvento ? batchFieldsEvento : batchFieldsFicha">
              </b-table>
            </template>

          </b-table>

          <h4 class="mb-3">Agrupado por Forma Pagamento</h4>
          <b-table
            :hover="false"
            borderless
            responsive="md"
            :items="reportByPaymentMethod"
            :fields="$gui.isEvento ? paymentMethodFieldsEvento : paymentMethodFieldsFicha"
            :filter-included-fields='filterOn'>

            <template v-slot:cell(batches)="data">
              <b-table
                :hover="true"
                outlined
                :items="data.item.batches"
                :fields="$gui.isEvento ? batchFieldsEvento : batchFieldsFicha">
              </b-table>
            </template>

          </b-table>
          </div> <!-- end v-if=false -->

        </b-col>
      </b-row>

    </b-container>

    <b-modal id="filter-operation"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Operação"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3" size="sm">
        <b-form-input
          v-model="search.event"
          placeholder="Pesquisa rápida"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.event" @click="search.event = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('events', $event)"
          :checked="filters.events"
          :options="eventsOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-origin"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Origem"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('origins', $event)"
          :checked="filters.origins"
          :options="originsOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-dealer"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      :title="'Filtrar por ' + $gui.dealer"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3" size="sm">
        <b-form-input
          v-model="search.dealer"
          placeholder="Pesquisa rápida"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.dealer" @click="search.dealer = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('dealers', $event)"
          :checked="filters.dealers"
          :options="dealersOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-batch"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      :title="'Filtrar por ' + $gui.batch"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3" size="sm">
        <b-form-input
          v-model="search.batch"
          placeholder="Pesquisa rápida"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.batch" @click="search.batch = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('batches', $event)"
          :checked="filters.batches"
          :options="batchesOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-number"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Número"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe os números e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('numbers', $event)"
          :value="filters.numbers"
          placeholder="Exemplo: 1,2,3"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.numbers" @click="filters.numbers = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-code"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Código"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe os códigos e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('codes', $event)"
          :value="filters.codes"
          placeholder="Exemplo: 05a2c30de2e4c19bd8b5ae855ca40f00"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.codes" @click="filters.codes = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-range"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Intervalo"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe o intervalo de números e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('rangeNumbers', $event)"
          :value="filters.rangeNumbers"
          placeholder="Exemplo: 1-25"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.rangeNumbers" @click="filters.rangeNumbers = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-payment-method"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Forma Pag."
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('paymentMethods', $event)"
          :checked="filters.paymentMethods"
          :options="paymentMethodOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-date"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      :ok-disabled="filters.createdAt.start === '' || filters.createdAt.end === ''"
      title="Filtrar por Data"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Para filtrar um <span class="font-weight-bold">intervalo de datas</span>, selecione dois dias. Para filtrar um <span class="font-weight-bold">dia específico</span>, clique duas vezes nele. Após isso clique em <span class="font-weight-bold">Filtrar</span>.</p>

      <div class="text-center">
        <calendar
          @input="updateForm('createdAt', $event)"
          :value="filters.createdAt"
          :min-date="eventCreatedAt"
        >
        </calendar>
      </div>
    </b-modal>

  </div>
</template>

<script>
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

import Vue from "vue";
import MaskedInput from 'vue-text-mask'
import Calendar from '@/components/Calendar'
import FilterStore from '@/filterStore'
import Gui from '@/gui'
import html2canvas from 'html2canvas'

const slugify = require('slugify')

export default {
  name: 'GroupedReportGet',
  components: {
    MaskedInput,
    Calendar
  },
  data () {
    return {
      currentStatus: null,
      organizer: '',
      reportToken: '',
      batches: [],
      events: [],
      dealers: [],
      reportName: '',
      data: [],
      generated_at: '',
      appliedFilters: [],
      dealerFieldsEvento: [
        {key: 'name', label: 'Revendedor', tdClass: ['align-middle', 'font-weight-bold']},
        {key: 'batches', label: 'Lotes'}
      ],
      dealerFieldsFicha: [
        {key: 'name', label: 'Ponto de Venda', tdClass: ['align-middle', 'font-weight-bold']},
        {key: 'batches', label: 'Produtos'}
      ],
      paymentMethodTotalFieldsEvento: [
        {key: 'name', label: 'Forma Pagamento', formatter: this.$options.filters.paymentMethod, tdClass: ['align-middle', 'font-weight-bold']},
        {key: 'print_value', label: 'Valor Vendas', formatter: this.$options.filters.currency, tdClass: ['text-primary', 'text-center'], thClass: 'text-center'}
      ],
      paymentMethodTotalFieldsFicha: [
        {key: 'name', label: 'Forma Pagamento', formatter: this.$options.filters.paymentMethod, tdClass: ['align-middle', 'font-weight-bold']},
        {key: 'print_value', label: 'Valor vendas', formatter: this.$options.filters.currency, tdClass: ['text-primary', 'text-center'], thClass: 'text-center'},
      ],
      operationsFields: [
        {key: 'name', label: 'Operação', tdClass: ['align-middle', 'font-weight-bold']},
        {key: 'payment_methods', label: 'Formas pagamento'}
      ],
      paymentMethodFieldsEvento: [
        {key: 'name', label: 'Forma Pagamento', formatter: this.$options.filters.paymentMethod, tdClass: ['align-middle', 'font-weight-bold']},
        {key: 'batches', label: 'Lotes'}
      ],
      paymentMethodFieldsFicha: [
        {key: 'name', label: 'Forma Pagamento', formatter: this.$options.filters.paymentMethod, tdClass: ['align-middle', 'font-weight-bold']},
        {key: 'batches', label: 'Produtos'}
      ],
      paymentMethod2FieldsEvento: [
        {key: 'name', label: 'Forma Pagamento', formatter: this.$options.filters.paymentMethod, tdClass: ['align-middle', 'font-weight-bold']},
        {key: 'print_value', label: 'Valor Vendas', formatter: this.$options.filters.currency, tdClass: ['text-primary', 'text-center'], thClass: 'text-center'}
      ],
      paymentMethod2FieldsFicha: [
        {key: 'name', label: 'Forma Pagamento', formatter: this.$options.filters.paymentMethod, tdClass: ['align-middle', 'font-weight-bold']},
        {key: 'print_value', label: 'Valor vendas', formatter: this.$options.filters.currency, tdClass: ['text-primary', 'text-center'], thClass: 'text-center'},
      ],
      batchFieldsEvento: [
        {key: 'batch', label: 'Lote'},
        {key: 'batch_value', label: 'Unitário', formatter: this.$options.filters.currency, tdClass: ['text-secondary', 'text-center'], thClass: 'text-center'},
        {key: 'print_amount', label: 'Total Ingresso', formatter: this.$options.filters.number, tdClass: ['text-primary', 'text-center'], thClass: 'text-center'},
        {key: 'print_value', label: 'Valor Ingresso', formatter: this.$options.filters.currency, tdClass: ['text-primary', 'text-center'], thClass: 'text-center'},
        {key: 'validate_amount', label: 'Total Validado', formatter: this.$options.filters.number, tdClass: ['text-success', 'text-center'], thClass: 'text-center'},
        {key: 'validate_value', label: 'Valor Validado', formatter: this.$options.filters.currency, tdClass: ['text-success', 'text-center'], thClass: 'text-center'}
      ],
      batchFieldsFicha: [
        {key: 'batch', label: 'Produto'},
        {key: 'batch_value', label: 'Preço atual', formatter: this.$options.filters.currency, tdClass: ['text-secondary', 'text-center'], thClass: 'text-center'},
        {key: 'batch_avg_value', label: 'Preço médio', formatter: this.$options.filters.currency, tdClass: ['text-secondary', 'text-center'], thClass: 'text-center'},
        {key: 'print_amount', label: 'Total vendas', formatter: this.$options.filters.number, tdClass: ['text-primary', 'text-center'], thClass: 'text-center'},
        {key: 'print_value', label: 'Valor vendas', formatter: this.$options.filters.currency, tdClass: ['text-primary', 'text-center'], thClass: 'text-center'},
      ],
      statusOptions: [
        { text: 'Ativos', value: 'active' },
        { text: 'Validados', value: 'validated' },
        { text: 'Cancelados', value: 'canceled' },
      ],
      typeOptions: [
        { text: 'Impressos', value: 'printed' },
        { text: 'Digitais', value: 'digital' },
      ],
      search: {
        dealer: '',
        batch: '',
        event: ''
      },
      filterOn: ['name'],
      filters: {
        limit: 0,
        events: [],
        dealers: [],
        batches: [],
        numbers: '',
        codes: '',
        rangeNumbers: '',
        createdAt: {
          start: '',
          end: ''
        },
        type: ['printed', 'digital'],
        origins: [],
        paymentMethods: [],
        status: ['active', 'validated']
      },
      originsOptions: [
        { text: 'Sistema', value: 'dashboard' },
        { text: 'Aplicativo', value: 'app' },
        { text: 'Loja virtual', value: 'shop' },
      ],
      paymentMethodOptions: [
        { text: 'Débito', value: 'debt' },
        { text: 'Crédito à Vista', value: 'cred' },
        { text: 'Crédito Parcelado', value: 'cred_parc' },
        { text: 'Dinheiro', value: 'dinh' },
        { text: 'Pix', value: 'pix' },
        { text: 'Boleto', value: 'bol' },
      ],
      eventCreatedAt: '',
      filterStore: ''
    }
  },
  beforeCreate () {
    let gui = new Gui('ficha')
    Object.defineProperty(Vue.prototype, '$gui', {value: gui, configurable: true})
  },
  async created () {
    const login = this.$session.get('login')
    this.filterStore = new FilterStore(login + '-' + this.$route.params.reportToken, this.$route.path)

    // let today = new Date()

    // if (!this.$gui.isEvento) {
    //   this.filters.createdAt.start = this.$moment(today.setHours(0, 0, 0)).format('DD/MM/YYYY HH:mm')
    //   this.filters.createdAt.end = this.$moment(today.setHours(23, 59, 59)).format('DD/MM/YYYY HH:mm')
    // }

    this.filters = this.filterStore.merge(this.filters)
  },
  async mounted () {
    this.organizer = this.$route.params.organizer
    this.reportToken = this.$route.params.token

    this.filters.type = ['printed', 'digital']
    await this.getEvents()
    await this.filter()
  },
  methods: {
    updateForm (input, value) {
      this.filters[input] = value
      this.filterStore.save(input, value)
    },
    downloadReport () {
      this.$wait.start()
      document.body.style.cursor = 'wait'

      const elementId = 'grouped-report'
      const filename = slugify(`easytick-relatorio-${this.reportName}-${this.generated_at}`, {lower: true}) + '.png'

      const element = document.getElementById(elementId)
      if (!element) {
          console.error(`Element with ID "${elementId}" not found.`)
          return
      }

      // Use html2canvas to capture the screenshot
      html2canvas(element)
        .then(canvas => {
            // Convert the canvas to a data URL
            const dataURL = canvas.toDataURL("image/png")

            // Create a link element to trigger the download
            const link = document.createElement("a")
            link.href = dataURL
            link.download = filename

            // Trigger the download
            document.body.appendChild(link) // Append to body for Firefox compatibility
            link.click()
            document.body.removeChild(link) // Clean up

            this.$wait.end()
            document.body.style.cursor = 'default'
        })
        .catch(error => {
            console.error("Failed to capture screenshot:", error)

            this.$wait.end()
            document.body.style.cursor = 'default'
        })
    },
    async getEvents () {
      let url = process.env.VUE_APP_URL_APP + `/b/grouped-reports/${this.reportToken}/events`
      const resp = await this.$http.get(url)
      this.events = resp.body.events
    },
    async getReport (filters) {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/grouped-reports/' + this.reportToken

      if (filters !== '' && filters !== undefined) {
        url = url + '?' + filters
      }

      try {
        const resp = await this.$http.get(url)

        this.reportName = resp.body.name
        this.data = resp.body.report
        this.generated_at = resp.body.generated_at

        if (resp.body.batches.length > 0) {
          this.batches = resp.body.batches
        }

        if (resp.body.dealers.length > 0) {
          this.dealers = resp.body.dealers
        }

        this.eventCreatedAt = this.$moment(resp.body.created_at).format('YYYY-MM-DD 00:00:00')

        this.currentStatus = STATUS_SUCCESS
      } catch (e) {
        console.error(e)
        this.currentStatus = STATUS_FAILED
      }
      return false
    },
    async filter () {
      let filters = []
      this.appliedFilters = []

      if (this.filters.origins.length > 0) {
        filters.push('origins=' + this.$_.join(this.filters.origins, ','))

        let v = []
        this.$_.each(this.filters.origins, f => {
          let s = this.$_.find(this.originsOptions, d => d.value === f)
          v.push(s.text)
        })
        let af = {
          filter: 'Origem',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.events.length > 0) {
        filters.push('events=' + this.$_.join(this.filters.events, ','))

        let v = []
        this.$_.each(this.filters.events, f => {
          let s = this.$_.find(this.events, d => d.id === f)
          if (s) {
            v.push(s.name)
          }
        })
        let af = {
          filter: 'Operação',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.dealers.length > 0) {
        filters.push('dealers=' + this.$_.join(this.filters.dealers, ','))

        let v = []
        this.$_.each(this.filters.dealers, f => {
          let s = this.$_.find(this.dealers, d => d.id === f)
          if (s) {
            v.push(s.name)
          }
        })
        let af = {
          filter: this.$gui.dealer,
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.batches.length > 0) {
        filters.push('batches=' + this.$_.join(this.filters.batches, ','))

        let v = []
        this.$_.each(this.filters.batches, f => {
          let s = this.$_.find(this.batches, d => d.id === f)
          if (s) {
            v.push(s.name)
          }
        })
        let af = {
          filter: this.$gui.batch,
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.limit > 0) {
        filters.push('limit=' + this.filters.limit)
      }

      if (this.filters.numbers !== '') {
        filters.push('numbers=' + this.filters.numbers)

        let af = {
          filter: 'Número',
          values: this.filters.numbers
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.codes !== '') {
        filters.push('codes=' + this.filters.codes)

        let af = {
          filter: 'Código',
          values: this.filters.codes
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.rangeNumbers !== '') {
        filters.push('range_numbers=' + this.filters.rangeNumbers)

        let split = this.$_.split(this.filters.rangeNumbers, '-', 2)

        let af = {
          filter: 'Intervalo',
          values: 'Do ' + split[0] + ' até o ' + split[1]
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.createdAt.start !== '') {
        let start = this.$moment(this.filters.createdAt.start, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('start_created_at=' + start + ':00')

        let af = {
          filter: 'Impressão',
          values: 'A partir de ' + this.filters.createdAt.start
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.createdAt.end !== '') {
        let end = this.$moment(this.filters.createdAt.end, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('end_created_at=' + end + ':59')

        let af = {
          filter: 'Impressão',
          values: 'Até ' + this.filters.createdAt.end
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.paymentMethods.length > 0) {
        filters.push('payment_methods=' + this.$_.join(this.filters.paymentMethods, ','))

        let v = []
        this.$_.each(this.filters.paymentMethods, f => {
          let s = this.$_.find(this.paymentMethodOptions, d => d.value === f)
          v.push(s.text)
        })
        let af = {
          filter: 'Forma Pag.',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.type.length > 0) {
        filters.push('type=' + this.$_.join(this.filters.type, ','))
      }

      if (this.filters.status.length > 0 ) {
        filters.push('status=' + this.$_.join(this.filters.status, ','))
      }

      if (filters.length > 0) {
        filters = this.$_.join(filters, '&')
      }

      await this.getReport(filters)
    },
    reset () {
      this.appliedFilters = []
      this.filters.dealers = []
      this.filters.batches = []
      this.filters.numbers = ''
      this.filters.codes = ''
      this.filters.rangeNumbers = ''
      this.filters.createdAt.start = ''
      this.filters.createdAt.end = ''
      this.filters.type = ['printed', 'digital']
      this.filters.origins = []
      this.filters.paymentMethods = []
      this.filters.status = ['active', 'validated']
      this.filters.events = []
      this.filterStore.clear()
    },
    async showAll () {
      this.reset()
      this.filters.type = ['printed', 'digital']
      this.filters.status = ['active', 'validated']
      await this.filter()
    }
  },
  computed: {
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },
    reportByBatch () {
      let batches = this.$_.groupBy(this.data, i => i.batch)
      let source = []

      this.$_.each(batches, batch => {
        let aux = this.$_.reduce(batch, (result, value, key) => {
          return {
            batch: value.batch,
            batch_value: value.batch_value,
            batch_avg_value: 0,
            print_amount: result.print_amount + value.print_amount,
            print_value: result.print_value + value.print_value,
            validate_amount: result.validate_amount + value.validate_amount,
            validate_value: result.validate_value + value.validate_value
          }
        }, {
          batch: '',
          batch_value: 0,
          batch_avg_value: 0,
          print_amount: 0,
          print_value: 0,
          validate_amount: 0,
          validate_value: 0
        })
        source.push(aux)
      })

      this.$_.each(source, (batch, i) => {
        source[i].batch_avg_value = batch.print_value / batch.print_amount
      })

      let totals = this.$_.reduce(this.data, (result, value, key) => {
        return {
          validate_amount: result.validate_amount + value.validate_amount,
          validate_value: result.validate_value + value.validate_value,
          print_amount: result.print_amount + value.print_amount,
          print_value: result.print_value + value.print_value
        }
      }, {
        print_amount: 0,
        print_value: 0,
        validate_amount: 0,
        validate_value: 0
      })

      source.push(totals)

      return source
    },
    reportByDealer () {
      let aux = []

      this.$_.each(this.data, i => {
        let found = this.$_.find(aux, elem => elem.name === i.dealer)

        if (!found) {
          aux.push({name: i.dealer, batches: [], sums: {print_amount: 0, print_value: 0, validate_amount: 0, validate_value: 0}})
        }

        let idx = this.$_.findIndex(aux, elem => elem.name === i.dealer)
        let idj = this.$_.findIndex(aux[idx].batches, elem => elem.batch === i.batch)

        // notFound
        if (idj === -1) {
          aux[idx].batches.push({
            batch: i.batch,
            batch_value: i.batch_value,
            batch_avg_value: 0,
            print_amount: i.print_amount,
            print_value: i.print_value,
            validate_amount: i.validate_amount,
            validate_value: i.validate_value
          })
        } else {
            // found
            aux[idx].batches[idj].print_amount += i.print_amount
            aux[idx].batches[idj].print_value += i.print_value
            aux[idx].batches[idj].validate_amount += i.validate_amount
            aux[idx].batches[idj].validate_value += i.validate_value
        }

        aux[idx].sums.print_amount += i.print_amount
        aux[idx].sums.print_value += i.print_value
        aux[idx].sums.validate_amount += i.validate_amount
        aux[idx].sums.validate_value += i.validate_value
      })

      // Calcula o preço médio
      for (let i = 0; i < aux.length; i++) {
        for (let j = 0; j < aux[i].batches.length; j++) {
          aux[i].batches[j].batch_avg_value = aux[i].batches[j].print_value / aux[i].batches[j].print_amount
        }
      }

      this.$_.each(aux, (v, i) => {
        aux[i].batches.push(aux[i].sums)
        delete aux[i].sums
      })

      return aux
    },
    reportByPaymentMethodTotal () {
      let aux = []
      let tot = {print_amount: 0, print_value: 0, validate_amount: 0, validate_value: 0}

      this.$_.each(this.data, i => {
        let found = this.$_.find(aux, elem => elem.name === i.payment_method)

        if (!found) {
          aux.push({name: i.payment_method, print_amount: 0, print_value: 0, validate_amount: 0, validate_value: 0})
        }

        let idx = this.$_.findIndex(aux, elem => elem.name === i.payment_method)

        aux[idx].print_amount += i.print_amount
        aux[idx].print_value += i.print_value
        aux[idx].validate_amount += i.validate_amount
        aux[idx].validate_value += i.validate_value

        tot.print_amount += i.print_amount
        tot.print_value += i.print_value
        tot.validate_amount += i.validate_amount
        tot.validate_value += i.validate_value
      })

      aux.push({name: 'tot', ...tot})

      return aux
    },
    reportByEvent () {
      let aux = []

      this.$_.each(this.data, i => {
        let found = this.$_.find(aux, elem => elem.name === i.event)

        if (!found) {
          aux.push({name: i.event, payment_methods: [], sums: {print_amount: 0, print_value: 0, validate_amount: 0, validate_value: 0}})
        }

        let idx = this.$_.findIndex(aux, elem => elem.name === i.event)
        let idj = this.$_.findIndex(aux[idx].payment_methods, elem => elem.name === i.payment_method)

        // notFound
        if (idj === -1) {
          aux[idx].payment_methods.push({
            name: i.payment_method,
            print_amount: i.print_amount,
            print_value: i.print_value,
            validate_amount: i.validate_amount,
            validate_value: i.validate_value
          })
        } else {
            // found
            aux[idx].payment_methods[idj].print_amount += i.print_amount
            aux[idx].payment_methods[idj].print_value += i.print_value
            aux[idx].payment_methods[idj].validate_amount += i.validate_amount
            aux[idx].payment_methods[idj].validate_value += i.validate_value
        }

        aux[idx].sums.name = 'tot'
        aux[idx].sums.print_amount += i.print_amount
        aux[idx].sums.print_value += i.print_value
        aux[idx].sums.validate_amount += i.validate_amount
        aux[idx].sums.validate_value += i.validate_value
      })

      this.$_.each(aux, (v, i) => {
        aux[i].payment_methods.push(aux[i].sums)
        delete aux[i].sums
      })

      return aux
    },
    reportByPaymentMethod () {
      let aux = []

      this.$_.each(this.data, i => {
        let found = this.$_.find(aux, elem => elem.name === i.payment_method)

        if (!found) {
          aux.push({name: i.payment_method, batches: [], sums: {print_amount: 0, print_value: 0, validate_amount: 0, validate_value: 0}})
        }

        let idx = this.$_.findIndex(aux, elem => elem.name === i.payment_method)
        let idj = this.$_.findIndex(aux[idx].batches, elem => elem.batch === i.batch)

        // notFound
        if (idj === -1) {
          aux[idx].batches.push({
            batch: i.batch,
            batch_value: i.batch_value,
            batch_avg_value: i.batch_avg_value,
            print_amount: i.print_amount,
            print_value: i.print_value,
            validate_amount: i.validate_amount,
            validate_value: i.validate_value
          })
        } else {
            // found
            aux[idx].batches[idj].print_amount += i.print_amount
            aux[idx].batches[idj].print_value += i.print_value
            aux[idx].batches[idj].validate_amount += i.validate_amount
            aux[idx].batches[idj].validate_value += i.validate_value
        }

        aux[idx].sums.print_amount += i.print_amount
        aux[idx].sums.print_value += i.print_value
        aux[idx].sums.validate_amount += i.validate_amount
        aux[idx].sums.validate_value += i.validate_value
      })

      this.$_.each(aux, (v, i) => {
        aux[i].batches.push(aux[i].sums)
        delete aux[i].sums
      })

      return aux
    },
    eventsOptions () {
      let filtered = this.events

      if (this.search.event) {
        filtered = this.$_.filter(this.events, b => {
          let searched = this.search.event.toLowerCase()
          return b.name.toLowerCase().indexOf(searched) >= 0
        })
      }

      return this.$_.map(filtered, b => {
        return {text: b.name, value: b.id}
      })
    },
    batchesOptions () {
      let filtered = this.batches

      if (this.search.batch) {
        filtered = this.$_.filter(this.batches, b => {
          let searched = this.search.batch.toLowerCase()
          return b.name.toLowerCase().indexOf(searched) >= 0
        })
      }

      return this.$_.map(filtered, b => {
        return {text: b.name, value: b.id}
      })
    },
    dealersOptions () {
      let filtered = this.dealers

      if (this.search.dealer) {
        filtered = this.$_.filter(this.dealers, d => {
          let searched = this.search.dealer.toLowerCase()
          return d.name.toLowerCase().indexOf(searched) >= 0
        })
      }

      return this.$_.map(filtered, b => {
        return {text: b.name, value: b.id}
      })
    },
    hasFilters () {
      return this.appliedFilters.length !== 0
    }
  }
}
</script>
